import Provider from "../../../common/providers/new/provider";
import BookmarkLink from "../models/bookmarkLink";

export default class BookmarkLinkProvider extends Provider<BookmarkLink> {

  replacer(route: string, obj: object, metadata: object = {}): string {
    const bookmarkFolderId = obj['bookmark_folder_id'];
    return route.replace(':bookmark_folder_id', bookmarkFolderId);
  }
}
